module.exports = __webpack_public_path__ + "img/androidTV-mid.1176f6.png";